<template>
  <div :class="className + ' video-group-box--thumb-link'">
    <router-link v-if="renderAsLink" :to="to" :class="className + ' video-group-box--thumb-link'">
      <div class="video-group-box--thumb">
        <img v-if="thumb" :src="thumb" />
      </div>
    </router-link>

    <div v-else class="video-group-box--thumb">
      <img v-if="thumb" :src="thumb" />
    </div>
  </div>
</template>

<style lang="less">
.video-group-box--thumb {
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  position: relative;

  img {
    display: block;
    margin: 0;
    padding: 0;

    width: 100%;
    height: auto;
    margin: auto;
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;

    object-fit: cover;
  }
}

.video-group-box--thumb-link {
  width: 100%;
}
</style>

<script>
import VideoProgress from "./VideoProgress";
export default {
  data: () => ({
    className: ""
  }),
  computed: {
    renderAsLink: function() {
      return !!this.$props.to;
    }
  },
  components: {
    "video-progress": VideoProgress
  },
  props: ["thumb", "value", "to"]
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoThumbProgress.vue